import { Alert, Divider, Flex, Skeleton } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { ReactComponent as RubIcon } from "images/coins/rubLargeIconRound.svg";
import { ReactComponent as MoneyIcon } from "images/other/money.svg";
import { ReactComponent as ClockIcon } from "images/other/clock.svg";
import { ReactComponent as LockIcon } from "images/other/lock.svg";

import { FeeStatistics, NominalAccount } from "interfaces/nominalAccounts";
import { DataStoreConstructor } from "stores/core/DataStoreConstructor";
import { BalanceItem, BalanceItemMain } from "../BalancesItems/BalanceItem";

interface IFeeItemsProps {
  store: DataStoreConstructor<FeeStatistics>;
}

export const FeeItems = observer((props: IFeeItemsProps) => {
  const { data, statuses, polling, stopPolling } = props.store;

  useEffect(() => {
    polling();

    return () => stopPolling();
  }, []);

  if (statuses.loading) {
    return <Skeleton active />;
  }

  if (statuses.fetchError) {
    return <Alert message="Ошибка при загрузке данных" type="error" />;
  }

  return (
    <Flex vertical gap="12px">
      <BalanceItemMain label="Всего комиссий" value={data.totalFee} icon={RubIcon} />

      <Divider className="margin-top-none margin-bottom-none" />

      <BalanceItem label="За текущий месяц" value={data.monthFee} icon={MoneyIcon} />
      <BalanceItem label="За сегодня" value={data.dayFee} icon={LockIcon} />
    </Flex>
  );
});
